import FotaWebLogo from "assets/logos/FotaWebLogo.svg?react";

import { LogoProps } from "./types";

const Logo = ({ ...props }: LogoProps) => {
    return <FotaWebLogo {...props} />;
};

export default Logo;
